// c:/Data/Fullstack/MyProjects/invest-ai/invest_FE/src/components/property/display/ImageLightbox.js
import React, { useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import './ImageLightbox.css';

const ImageLightbox = ({ src, onClose, onNext, onPrevious, hasNext, hasPrevious, currentIndex, totalCount }) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'ArrowRight' && hasNext) {
        onNext();
      } else if (e.key === 'ArrowLeft' && hasPrevious) {
        onPrevious();
      } else if (e.key === 'Escape') {
        onClose();
      }
    },
    [onNext, onPrevious, onClose, hasNext, hasPrevious]
  );

  useEffect(() => {
    // Add event listener when the lightbox is open
    document.addEventListener('keydown', handleKeyDown);

    // Clean up event listener when the lightbox closes
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  if (!src) {
    return null;
  }

  const handleOverlayClick = (e) => {
    // Close only if the overlay itself is clicked, not the content inside
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className="lightbox-overlay" onClick={handleOverlayClick}>
      <button className="lightbox-close-btn" onClick={onClose} aria-label="Close image view">
        &times;
      </button>

      {totalCount > 0 && (
        <div className="lightbox-counter">
          {currentIndex + 1} / {totalCount}
        </div>
      )}

      {hasPrevious && (
        <button className="lightbox-nav-btn prev" onClick={onPrevious} aria-label="Previous image">
          &#10094;
        </button>
      )}

      <div className="lightbox-content">
        <img src={src} alt="Enlarged property view" className="lightbox-image" />
      </div>

      {hasNext && (
        <button className="lightbox-nav-btn next" onClick={onNext} aria-label="Next image">
          &#10095;
        </button>
      )}
    </div>,
    document.body
  );
};

export default ImageLightbox;
